import {Routes} from '@angular/router';
import {authGuard} from './auth-guard.config';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../app/components/layouts/login-layout/login-layout').then(m => m.LoginLayout),
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', loadComponent: () => import('../app/pages/login/login-page.component').then(m => m.LoginPage) },
    ]
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('../app/components/layouts/default-layout/default-layout').then(m => m.DefaultLayout),
    children: [
      { path: '', loadComponent: () => import('../app/pages/home/home-page.component').then(m => m.HomePage) }
    ]
  },
  {
    path: 'registry',
    canActivate: [authGuard],
    loadComponent: () => import('../app/components/layouts/default-layout/default-layout').then(m => m.DefaultLayout),
    children: [
      { path: ':element/create', loadComponent: () => import('../app/pages/create/create-page.component').then(m => m.CreatePage) },
      { path: ':element/:id/detail', loadComponent: () => import('../app/pages/detail/detail-page.component').then(m => m.DetailPage) },
      { path: ':element/:id/edit', loadComponent: () => import('../app/pages/edit/edit-page.component').then(m => m.EditPage) },
      { path: ':element/list', loadComponent: () => import('../app/pages/list/list-page.component').then(m => m.ListPage) },
    ]
  },
  { path: '**', redirectTo: 'home' }
];
